import { IDLE, LOADING, SUCCESS, ERROR } from '../../enums/states';
import { LOGIN, LOGIN_ERROR, LOGIN_SET_DATA, LOGIN_SUCCESS } from '../actions/login';
import { createReducer } from './utils/reducer';

const initialState = {
  data: null,
  error: null,
  state: IDLE,
};

const handlers = {
  [LOGIN]: (state, action) => {
    return {
      ...state,
      state: LOADING,
    };
  },
  [LOGIN_SUCCESS]: (state, action) => {
    return {
      ...state,
      state: SUCCESS,
      data: action.payload,
    };
  },
  [LOGIN_ERROR]: (state, action) => {
    return {
      ...state,
      state: ERROR,
      error: action.error,
    };
  },
  [LOGIN_SET_DATA]: (state, action) => {
    return {
      ...state,
      state: IDLE,
      data: action.payload,
    };
  },
};

export default createReducer(initialState, handlers);
